import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RoleService, SwalService, TranslateService } from '__services';
import { Observable } from 'rxjs';
import { APP_ROUTES } from '../routes/app-routes';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(
    private router: Router,
    private roleService: RoleService,
    private translationService: TranslateService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let hasAccess = true;
    let moduleId = next.data.module_id;
    const featureId = next.data.feature_id;
    const permission = next.data.permission;
    if (moduleId) {
      hasAccess = this.roleService.accessModule(moduleId);
    }
    if (featureId) {
      if (typeof featureId === 'number') {
        hasAccess = this.roleService.accessFeature(featureId, moduleId, permission);
      }
      else {
        moduleId = next.parent.data.module_id;
        hasAccess = this.roleService.accessFeature(featureId, moduleId, permission);
      }
    }
    if (!hasAccess) {
      SwalService.error(this.translationService.translate('Permission Denied')).then(() => {
        this.router.navigate([APP_ROUTES.DASHBOARD]);
      });
    }
    return hasAccess;
  }
}
